import React, { Component } from 'react';
import classNames from 'classnames';
import Chains from './chains';
import Segments from './segments';
import Turnover from './turnover';
import Size from './size';
import Store from './store';
import { UnitsVisibility } from '../../../districts/types/units-visibility';
import './styles.scss';


class Filters extends Component {

    registeredFilters = [];

    state = {
        filters: null,
        filteredUnits: null
    };

    registerFilter(filter) {
        this.registeredFilters.push(filter);
        //Filter when all filters registered
        if (this.registeredFilters.length === 4) {
            this.previewFilter((filteredUnits) => {
                this.props.setDataForSelected(filteredUnits)
            });
        }
    }

    previewFilter(cb) {
        let filteredUnits = [...this.props.allUnits];
        let filters = {};

        this.registeredFilters.forEach(f => {

            const filterData = f.filter(filteredUnits);
            filteredUnits = filterData.filteredUnits;
            filters = {
                ...filters,
                ...filterData.filter
            };
        });

        this.setState({
            filteredUnits,
            filters
        }, () => {

            this.props.applyFilters(this.state.filteredUnits, this.state.filters);

            if (cb) {   
                cb(this.state.filteredUnits);
            }
        });
    }

    resetFilters() {
        this.registeredFilters.forEach(f => {
            f.reset();
        });
    }

    render() {
        const props = this.props;
        if (!props.filters) return null;
        
        const unitLocalization = this.props.type === 'foodservice' ? 'enheter' : 'butiker';

        return (
            <section className={classNames({
                'map-filters': true,
                'map-filters--is-open': this.props.filterModalIsOpen
            })}>
                <div className="map-filters__modal">
                    <header className="map-filters__modal-header">
                        <h1 className="map-filters__modal-heading">Filtrera: 
                            {props.unitsVisible === UnitsVisibility.AREA ?
                                <span className="map-filters__modal-heading-meta"><strong> {props.numberOfUnits}st</strong> {unitLocalization} (av totalt <strong>{props.totalUnitsInAreas}st</strong>) i säljdistrikt</span>
                                : 
                                <span className="map-filters__modal-heading-meta"><strong> {props.units.length}st</strong> {unitLocalization} (<strong>{props.numberOfUnits}st</strong> i säljdistrikt)</span>
                            }
                        </h1>
                        <button className="map-filters__modal-close" type="button" onClick={() => this.props.closeModal()}></button>
                    </header>
                    <div className="map-filters__modal-content">
                        {props.type !== 'foodservice' &&
                            <Turnover {...props} 
                                heading="Omsättning"
                                registerFilter={(filter) => this.registerFilter(filter)} 
                                previewFilter={() => this.previewFilter()} />
                        }

                        {props.type === 'foodservice' &&
                            <Segments {...props} 
                                    registerFilter={(filter) => this.registerFilter(filter)} 
                                    previewFilter={() => this.previewFilter()} />
                        }

                        <Chains {...props} 
                                registerFilter={(filter) => this.registerFilter(filter)} 
                                previewFilter={() => this.previewFilter()} />

                        {props.type !== 'foodservice' &&
                            <Size {...props} 
                                heading="Säljyta"
                                registerFilter={(filter) => this.registerFilter(filter)} 
                                previewFilter={() => this.previewFilter()} />
                        }
                        <Store {...props} 
                            registerFilter={(filter) => this.registerFilter(filter)} 
                            previewFilter={() => this.previewFilter()}
                            type={props.type} />

                        <footer className="map-filters__modal-footer">
                            <button className="map-filters__reset" type="button" onClick={() => this.resetFilters()}>Återställ filter</button>
                            {/*<Button modifiers={{
                            'map-filters__apply': true 
                            }}type="button" onClick={() => this.props.applyFilters(this.state.filteredUnits, this.state.filters)}>Visa {this.state.filteredUnits && this.state.filteredUnits.length}</Button>*/}
                        </footer>
                    </div>
                </div>
            </section>
        );
    }
};

export default Filters;